import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Amount", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Use negative amounts to remove money from a player. ")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" This action will ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" from the player. ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode("input", {
        type: "number",
        onKeypress: _cache[1] || (_cache[1] = $event => (_ctx.inputTransformer($event, _ctx.action.amount))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.amount = $event))
      }, null, 544), [
        [
          _vModelText,
          _ctx.action.amount,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createVNode("p", null, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createVNode("b", null, _toDisplayString(_ctx.action.amount >= 0 ? "add" : "remove") + " " + _toDisplayString(Math.abs(_ctx.action.amount)) + " money ", 1),
      _hoisted_8
    ])
  ]))
}